   /*==========================================================================================================
  FILTERS
  ==========================================================================================================*/
   angular
    .module('vppApp')
    .filter("dateOnly", function(){
        return function(input){
            return input.split(' ')[0];
        };
    });
